import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import * as faceapi from 'face-api.js';

import ScrollToTop from './services/Utils';
import PrivateRoute from './private';
import AuthLayout from './layouts/Auth.js';
import MainLayout from './layouts/MainPanel.js';

const queryClient = new QueryClient();

const AppInitializer = ({ children }) => {
  useEffect(() => {
    const loadModels = async () => {
      try {
        await faceapi.nets.tinyFaceDetector.loadFromUri('/models');
        console.log('FaceAPI models loaded ✅');
      } catch (err) {
        console.error('FaceAPI load error ❌', err);
      }
    };
    loadModels();
  }, []);

  return children;
};

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop /> 
    <QueryClientProvider client={queryClient}>
      <AppInitializer>
        <Switch>
          <Route path={'/auth'} component={AuthLayout} />
          <PrivateRoute path={'/'} component={MainLayout} />
        </Switch>
      </AppInitializer>
    </QueryClientProvider>
  </BrowserRouter>,
  document.getElementById('root')
);